import { AdminAccountIndemnitySummary } from "@portal/api/account/admin";
import { FC } from "react";
import { IndemnitorRow } from "./IndemnitorRow";

export type AdminAccountWaivedIndemnitorsListProps = {
	indemnitySummary: AdminAccountIndemnitySummary;
};

export const AdminAccountWaivedIndemnitorsList: FC<AdminAccountWaivedIndemnitorsListProps> = ({
	indemnitySummary,
}) => {
	return (
		<div
			data-testid="admin-account-waived-indemnitors"
			className="flex flex-col space-y-[14px] w-fit min-w-[70%] auto-rows-min"
		>
			<div className="flex flex-col space-y-2">
				{indemnitySummary.indemnityWaivers.companies.map((waiver, index) => (
					<IndemnitorRow key={index} name={waiver.name} />
				))}
				{indemnitySummary.indemnityWaivers.individuals.map((indemnitor, index) => (
					<IndemnitorRow key={index} name={indemnitor.name} email={indemnitor.email} />
				))}
			</div>
		</div>
	);
};
